







import React, { useState } from 'react';

const ResearchReport = () => {
  const [processOpen, setProcessOpen] = useState(1);

  // Service process steps
  const processSteps = [
    {
      title: '01. Scoping',
      body: 'Align objectives, KPIs, and hypotheses.'
    },
    {
      title: '02. Methodology',
      body: 'Choose data sources and research tools.'
    },
    {
      title: '03. Collection',
      body: 'Surveys, interviews, market & technical analysis.'
    },
    {
      title: '04. Insight',
      body: 'Visualise data, build SWOT & gap analyses.'
    },
    {
      title: '05. Refresh',
      body: 'Ongoing trend monitoring and updates.'
    }
  ];

  return (
    <div className="page_wrapper">
      <main className="page_content">
        {/* Banner Section */}
        <section className="page_banner_section text-center" style={{ backgroundImage: "url('assets/images/shapes/bg_pattern_3.svg')",marginTop: '90px' }}>
          <div className="container">
            <div className="heading_focus_text text-white">
              Service <span className="badge bg-secondary">Details </span>
            </div>
            <h1 className="page_title mb-0 text-white">Research & Report</h1>
          </div>
        </section>

        {/* Service Details Section */}
        <section className="service_details_section section_space bg-light">
          <div className="container">
            <div className="details_item_image position-relative">
              <img src="assets/images/service-details/Research & Report Services.jpg" alt="Service Details Image" />
            </div>
            <h2 className="details_item_title">Research & Report Services</h2>
            <p>
              Turn data into decisive action.
            </p>
            <p>
              We perform deep research and package findings into clear, executive-ready reports that guide strategy and reduce risk.
            </p>

            <h3 className="details_item_info_title">Service Process</h3>
            <div className="row mb-5 align-items-center justify-content-lg-between">
              <div className="col-lg-6">
                <div className="accordion" id="service_process_faq">
                  {processSteps.map((step, idx) => (
                    <div className="accordion-item" key={idx}>
                      <div
                        className={`accordion-button${processOpen === idx + 1 ? '' : ' collapsed'}`}
                        role="button"
                        onClick={() => setProcessOpen(processOpen === idx + 1 ? null : idx + 1)}
                        aria-expanded={processOpen === idx + 1}
                        aria-controls={`collapse_${idx}`}
                      >
                        {step.title}
                      </div>
                      <div
                        id={`collapse_${idx}`}
                        className={`accordion-collapse collapse${processOpen === idx + 1 ? ' show' : ''}`}
                        data-bs-parent="#service_process_faq"
                      >
                        <div className="accordion-body">
                          <p className="m-0">{step.body}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-5">
                <ul className="content_layer_group unordered_list_block text-center">
                  {processSteps.map((step, idx) => (
                    <li
                      className={`accordion-button${processOpen === idx + 1 ? '' : ' collapsed'}`}
                      role="button"
                      key={idx}
                      onClick={() => setProcessOpen(processOpen === idx + 1 ? null : idx + 1)}
                      aria-expanded={processOpen === idx + 1}
                      aria-controls={`collapse_${idx}`}
                    >
                      <span>{step.title.split('. ')[1]}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <h3 className="details_item_info_title">Services Outcome</h3>
            <p className="mb-4">
              Actionable intelligence that backs big decisions with real evidence.
            </p>
            <div className="row mb-4">
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Clear competitive positioning
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Data-driven roadmap validation
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Reduced investment risk
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Visual dashboards for quick buy-in
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Proprietary datasets for future use
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src="assets/images/icons/icon_check_3.svg" alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Continuous market intelligence feed
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services/data research.jpg" alt="Service Details Image" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services/market analysis.jpg" alt="Service Details Image" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="assets/images/services/business report.jpg" alt="Service Details Image" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call To Action Section */}
        <section className="calltoaction_section parallaxie" style={{ backgroundImage: "url('assets/images/backgrounds/staffing.jpg')" }}>
          <div className="container text-center">
            <div className="heading_block text-white">
              <h2 className="heading_text">
                Ready to Work, Let's Chat
              </h2>
              <p className="heading_description mb-0">
                Our team of experts is ready to collaborate with you every step of the way, from initial consultation to implementation.
              </p>
            </div>
            <a className="btn btn-primary" href="/contact">
              <span className="btn_label" data-text="Contact Us Today!">Contact Us Today!</span>
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right"></i>
              </span>
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ResearchReport;
